import React from 'react';
import PropTypes from 'prop-types';
import Alert from 'react-s-alert';

import getFileName from 'utils/getFileName';
import ArModels from 'api/resources/arModels';
import { processErrorByAlert } from 'utils/getErrors';
import { Deserializer } from 'jsonapi-serializer';

import ButtonLoader from 'components/Loader/ButtonLoader';
import PrimaryButton from 'styled/Buttons/PrimaryButton';
import SectionHeader from 'styled/Page/SectionHeader';
import RightColumnBody from 'styled/Page/RightColumnBody';
import ARFormElements from 'admin-editor/components/ARFormElements';

class LoadARModel extends React.Component {
  state = {
    loading: false,
    title: '',
    cover: undefined,
    IOSModel: undefined,
    AndroidModel: undefined,
    isShowInFeed: false,
  }

  handleCheckboxChange = ({ target }) => {
    this.setState({ isShowInFeed: target.checked });
  }

  handleTitleChange = ({ target }) => {
    this.setState({ title: target.value });
  }

  handleCoverLoad = (file) => {
    this.setState({
      cover: {
        filename: getFileName({
          url: file.attributes.path,
          type: '/ar',
        }),
        file_type: file.attributes.content_type,
        file_size: file.attributes.size,
        width: file.attributes.width,
        height: file.attributes.height,
        medialib_item_id: file.id,
      },
    });
  }

  handleIOSModelLoad = (file) => {
    this.setState({
      IOSModel: {
        filename: getFileName({
          url: file.attributes.path,
          type: '/ar',
        }),
        file_type: file.attributes.content_type,
        file_size: file.attributes.size,
        url: file.attributes.path,
        medialib_item_id: file.id,
      },
    });
  }

  handleAndroidModelLoad = (file) => {
    this.setState({
      AndroidModel: {
        filename: getFileName({
          url: file.attributes.path,
          type: '/ar',
        }),
        file_type: file.attributes.content_type,
        file_size: file.attributes.size,
        url: file.attributes.path,
        medialib_item_id: file.id,
      },
    });
  }

  handleSubmit = async (e) => {
    e.preventDefault();

    if (!this.state.cover) {
      processErrorByAlert('Поле "обложка" обязательно для заполнения');
      return;
    }

    if (!this.state.IOSModel) {
      processErrorByAlert('Поле модели для IOS обязательно для заполнения');
      return;
    }

    if (!this.state.AndroidModel) {
      processErrorByAlert('Поле модели для Android обязательно для заполнения');
      return;
    }

    this.setState({ loading: true });

    try {
      const response = await ArModels.create({
        body: {
          data: {
            type: 'augmented_reality_model',
            attributes: {
              title: this.state.title,
              is_active: this.state.isShowInFeed,
            },
            relationships: {
              cover: {
                data: {
                  type: 'image',
                  attributes: this.state.cover,
                },
              },
              ios_file: {
                data: {
                  type: 'augmented_reality_file',
                  attributes: this.state.IOSModel,
                },
              },
              android_file: {
                data: {
                  type: 'augmented_reality_file',
                  attributes: this.state.AndroidModel,
                },
              },
            },
          },
        },
        include: 'cover',
      });
      const model = await new Deserializer({ keyForAttribute: 'camelCase' }).deserialize(response);
      this.props.onCreate(model);

      Alert.success('Модель успешно добавлена');
      this.setState({
        loading: false,
        title: '',
        cover: undefined,
        IOSModel: undefined,
        AndroidModel: undefined,
        isShowInFeed: false,
      });
    } catch (err) {
      processErrorByAlert(err);
      this.setState({ loading: false });
    }
  }

  render() {
    return (
      <React.Fragment>
        <SectionHeader>Добавить модель</SectionHeader>

        <RightColumnBody
          as="form"
          style={{ paddingBottom: '40px' }}
          onSubmit={this.handleSubmit}
        >

          <ARFormElements
            checkboxId="showInFeedLoad"
            title={this.state.title}
            cover={this.state.cover}
            IOSModel={this.state.IOSModel}
            AndroidModel={this.state.AndroidModel}
            isShowInFeed={this.state.isShowInFeed}
            onIOSModelLoad={this.handleIOSModelLoad}
            onAndroidModelLoad={this.handleAndroidModelLoad}
            onCoverLoad={this.handleCoverLoad}
            onTitleChange={this.handleTitleChange}
            onCheckboxChange={this.handleCheckboxChange}
          />

          <PrimaryButton type="submit" style={{ width: '127px', marginTop: '40px' }}>
            {this.state.loading ? <ButtonLoader /> : 'загрузить'}
          </PrimaryButton>
        </RightColumnBody>
      </React.Fragment>
    );
  }
}

LoadARModel.defaultProps = {
  onCreate: () => {},
};

LoadARModel.propTypes = {
  onCreate: PropTypes.func,
};

export default LoadARModel;
